import { faHome } from '@fortawesome/free-solid-svg-icons';
import { NavigationMenuItem } from 'types/NavigationTypes';

// Define the menu items here
export const navigationConfig: { [key: string]: NavigationMenuItem } = {
    dashboard: { 
        name: 'nav.dashboard_label', 
        icon: faHome,
        route: '/',
        subMenu: [
            { name: 'nav.trial_page_label', route: '/trial-homepage' },
            { name: 'nav.dashboard_label', route: '/dashboard' },
            { name: 'nav.admin_dashboard_label', route: '/admin-dashboard' },
            { name: 'nav.tasks_label', route: '/tasks', activeFeature: 'office_tasks' },
            { name: 'nav.calendar_label', route: '/calendar', inActiveFeature: 'scheduling' },
            { name: 'nav.email_label', route: '/emails' },
            { name: 'nav.sms_label', route: '/sms-messages', activeFeature: 'sms_reminders' },
        ]
    },
    proposals: {
        name: 'nav.sales_label',
        route: '/proposals',
        subMenu: [
            { name: 'nav.deals_label', route: '/deals', activeFeature: 'deals' },
            { name: 'nav.proposals_label', route: '/proposals', activeFeature: 'proposals' },
            { name: 'nav.orders_label', route: '/orders', activeFeature: 'orders' },   
        ]
    },
    tickets: {
        name: 'nav.tickets_label',
        route: '/tickets',
        activeFeature: 'tickets'
    },
    jobs: {
        name: 'nav.activities_label',
        route: '/scheduling',
        collapseSingleSubItem: true, // With only the timesheets left the main item takes its name and loses the sub menu
        subMenu: [
            { name: 'nav.scheduling_label', route: '/scheduling', activeFeature: 'scheduling' },
            { name: 'nav.jobs_label', route: '/jobs', activeFeature: 'jobs' },
            { name: 'nav.projects_label', route: '/projects', activeFeature: 'projects' },
            { name: 'nav.contracts_label', route: '/contracts', activeFeature: 'contract_management' },
            { name: 'nav.timesheet_label', route: '/user-hours', activeFeature: 'manage_timesheets' },
        ]
    },
    invoices: {
        name: 'nav.invoices_label',
        route: '/invoices',
        activeFeature: 'invoices',
        collapseSingleSubItem: true, // Without the periodic invoices the main item keeps its name and loses the sub menu
        subMenu: [
            { name: 'nav.invoices_label', route: '/invoices', activeFeature: 'invoices' },
            { name: 'nav.periodic_invoices_label', route: '/invoices/periodic', activeFeature: 'periodic_invoices' },
        ]
    },
    team: { 
        name: 'nav.team_label', 
        route: '/employees',
        subMenu: [
            // { name: 'nav.timesheet_label', route: '/timesheet', activeFeature: 'manage_timesheets' },
            { name: 'nav.employees_label', route: '/employees', activeFeature: 'hrm' },
            { name: 'nav.leave_requests_label', route: '/leave-requests', activeFeature: 'leave_requests' },
            { name: 'nav.expenses_label', route: '/expenses', activeFeature: 'expenses' },
        ]
    },
    products: { 
        name: 'nav.products_label', 
        route: '/products', 
        subMenu: [
            { name: 'nav.products_label', route: '/products', activeFeature: 'products' },
            { name: 'nav.hourly_rates_label', route: '/hourly-rates', activeFeature: 'products' },
            // { name: 'nav.services_label', route: '/services', activeFeature: 'products' },
            { name: 'nav.inventory_label', route: '/inventory', activeFeature: 'inventory' },
            { name: 'nav.stockrooms_label', route: '/stockrooms', activeFeature: 'stockrooms', allowedFeature: 'inventory' },
            { name: 'nav.purchases_label', route: '/purchases', activeFeature: 'purchases' },
            { name: 'nav.categories_label', route: '/product_categories', activeFeature: 'product_categories', allowedFeature: 'products' },
        ]
    },
    contacts: { 
        name: 'nav.contacts_label', 
        route: '/contacts', 
        subMenu: [
            { name: 'nav.clients_label', route: '/contacts/clients', activeFeature: 'contacts', group: 'relations' },
            { name: 'nav.suppliers_label', route: '/contacts/suppliers', activeFeature: 'purchases', group: 'relations' },
            { name: 'nav.leads_label', route: '/contacts/leads', activeFeature: 'contacts', group: 'relations' },
            { name: 'nav.organizations_label', route: '/contacts/organizations', activeFeature: 'contacts', group: 'entities' },
            { name: 'nav.persons_label', route: '/contacts/persons', activeFeature: 'contacts', group: 'entities' },
            { name: 'nav.work_locations_label', route: '/contacts/work-locations', activeFeature: 'contacts', group: 'places' },
            { name: 'nav.asset_management_label', route: '/contacts/assets', activeFeature: 'asset_management', group: 'places' },
            { name: 'nav.newsletters_label', route: '/contacts/newsletters', activeFeature: 'newsletters', group: 'newsletters', alignRight: true },
        ]
    },
}